import { render, staticRenderFns } from "./TrxRuleGroupEdit.vue?vue&type=template&id=6a2515a4&"
import script from "./TrxRuleGroupEdit.vue?vue&type=script&lang=js&"
export * from "./TrxRuleGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports